import config from '~/config';
import Raven from 'raven-js';

Raven.config(config.SENTRY_URL).setRelease(config.RELEASE_ID).install();
require('./pendo.js');
